<script setup>
import { computed } from 'vue';

const props = defineProps({
    color: {
        type: String,
        default: 'neutral',
        validator: (value) => ['success', 'warning', 'error', 'info', 'accent', 'winter', 'summer', 'neutral'].includes(value),
    },
});

const colorClasses = computed(() => ({
    success: 'bg-success-soft text-success',
    warning: 'bg-warning-soft text-warning',
    error: 'bg-error-soft text-error',
    info: 'bg-info-soft text-info',
    accent: 'bg-accent-soft text-accent',
    winter: 'bg-winter-soft text-winter',
    summer: 'bg-summer-soft text-summer',
    neutral: 'bg-canvas text-ink-light border border-line',
}[props.color]));
</script>
<template>
<span
    class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap"
    :class="colorClasses">
    <slot />
</span>
</template>
